// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"316":"0e4f8f73","714":"82d6280a"}[chunkId] + ".chunk.css";
};